/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Remove_WundoInputs */



/**
* | output |
* | --- |
* | "Remove Wundo" |
*
* @param {Meeting_Remove_WundoInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_remove_wundo = /** @type {((inputs?: Meeting_Remove_WundoInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Remove_WundoInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo verwijderen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer Wundo")
	return /** @type {LocalizedString} */ ("Remove Wundo")
});